// extracted by mini-css-extract-plugin
export default {"tab-container":"Tabs_tab-container__9U-ez","tab-item":"Tabs_tab-item__6-hYX","badge":"Tabs_badge__sC-3n","active":"Tabs_active__2WVed"};